import React, {useEffect,useState} from "react";
import { Navigation } from "../components/navigation";
import { Header } from "../components/header";
import { Contact } from "../components/contact";
import OptimizedImage from "../components/OptimizedImage";
import JsonData from "./../data/data.json";

import facilitymaintain from "../data/services/facilitymaintain.json";
import { NavigationCommon } from "../components/navigationCommon";
import { About } from "../components/about";
import { Services } from "../components/services";
import { Gallery } from "../components/gallery";
import Projects from "../components/projects";

const FacilityMaintainServicePage = () => {
   const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);
  return (
    <div>
      {/* Navigation */}
      <Navigation />
 <Header data={facilitymaintain.Header} />
      {/* Hero Banner */}
      <section
        className="service-hero"
        style={{
          backgroundImage: "url(/img/services/electrical-banner.jpg)"
        }}
      >
       
      </section>

      {/* Main Content */}
{/* Facility Maintenance Services */}
<section
  id="facility-maintenance"
  className="container"
  style={{
    paddingTop: "80px",
    paddingBottom: "0px"
  }}
>
  <div className="row">
    <div className="col-md-10 col-md-offset-1 service-content">

      {/* Top Image */}
      <div
        style={{
          width: "100%",
          maxWidth: "900px",
          margin: "0 auto 40px",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 12px 30px rgba(0, 0, 0, 0.15)"
        }}
      >
        <OptimizedImage
          src="/img/services/facility-maintenance.jpg"
          alt="Facility Maintenance Services"
          width={900}
          height={320}
          placeholder={true}
        />
      </div>

      <h2 className="service-title">
        Facility Maintenance Services in Singapore
      </h2>

      <p className="service-intro">
        <strong>Aerolines Engineering & Construction Pte Ltd</strong> provides
        comprehensive <strong>facility maintenance services</strong> for
        commercial, industrial, and institutional properties across Singapore.
        Our solutions ensure facilities remain <strong>safe, functional, and
        well-maintained</strong> while minimising operational disruptions and
        maintenance costs.
      </p>

      <div className="service-section">
        <h3>Electrical Maintenance Works</h3>
        <p>
          Routine <strong>inspections, repairs, replacements, and fault
          troubleshooting</strong> to ensure safe and uninterrupted electrical
          operations.
        </p>
      </div>

      <div className="service-section">
        <h3>Painting & Tiling Works</h3>
        <p>
          Professional <strong>painting and tiling services</strong> delivering
          durable, high-quality finishes for commercial and industrial spaces.
        </p>
      </div>

      <div className="service-section">
        <h3>Renovation & Reinstatement Works</h3>
        <p>
          <strong>Layout modifications, upgrades, and reinstatement projects </strong>
          delivered safely, efficiently, and in compliance with regulations.
        </p>
      </div>

      <div className="service-section">
        <h3>Door Repair & Replacement Services</h3>
        <p>
          Repair and replacement services ensuring <strong>security, safety,
          and functionality</strong> of doors and access systems.
        </p>
      </div>

      <div className="service-section">
        <h3>Exhaust Fan Repair & Replacement</h3>
        <p>
          Maintenance and replacement services to improve <strong>ventilation
          efficiency and indoor air quality</strong>.
        </p>
      </div>

      <div className="service-section">
        <h3>Facility Preventive Maintenance Contracts</h3>
        <p>
          <strong>Scheduled preventive maintenance programs</strong> designed to
          reduce downtime, extend asset life, and control long-term costs.
        </p>
      </div>

    </div>
  </div>
</section>

<About data={landingPageData.About} />
              <Services data={landingPageData.Services} />
              {/* <Gallery data={landingPageData.Gallery} /> */}
                 <Projects />

      {/* Contact */}
             <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default FacilityMaintainServicePage;
